module.exports = __webpack_public_path__ + "static/media/pay-payatcounter-off.3d614d93.png";